export const TEXT_LIMITS = {
  min: 1,
  max: 63206,
  warningThreshold: 0.9,
};

export const getTrimmedLength = (value = "") => value.trim().length;

export const getTextValidationState = (value = "", options = {}) => {
  const min = options.min ?? TEXT_LIMITS.min;
  const max = options.max ?? TEXT_LIMITS.max;
  const warningThreshold =
    options.warningThreshold ?? TEXT_LIMITS.warningThreshold;
  const normalizedValue = typeof value === "string" ? value : String(value ?? "");
  const rawLength = normalizedValue.length;
  const trimmedLength = getTrimmedLength(normalizedValue);
  const isEmpty = trimmedLength < min;
  const isTooLong = rawLength > max;
  const isValid = !isEmpty && !isTooLong;
  const isNearLimit = !isTooLong && rawLength >= Math.floor(max * warningThreshold);
  const remaining = max - rawLength;

  return {
    rawLength,
    trimmedLength,
    isEmpty,
    isTooLong,
    isValid,
    isNearLimit,
    remaining,
    min,
    max,
  };
};

// VIVA-353 (CA-02): limite del comentario de un evento. Se declara junto a los
// demas limites de texto para que la caja de comentarios use el mismo
// `getTextValidationState` que el resto de las pantallas con textarea.
export const EVENT_COMMENT_MAX_LENGTH = 2000;
